import React from 'react';
import {ISvgIconProps} from '../../basic-ui-components/icon/svg-icon/svg.icon';
import {IThemeIcons} from './sections/theme-icons.interface';
import {ThemeDefaultIcons} from '../defaults/icons-registry';
import { ITwoCharsIconProps } from '../defaults/icons/two-chars.icon';
import {ILocationIconProps} from '../defaults/icons/location.icon';

export class ThemeIconsFactory implements IThemeIcons {
    constructor(private readonly _specificThemeIcons: Partial<IThemeIcons> | null) {
        this._specificThemeIcons = this._specificThemeIcons || {};
    }

    private _getIcon<T extends ISvgIconProps>(key: keyof IThemeIcons): React.ComponentType<T> {
        if(this._specificThemeIcons[key]) {
            return this._specificThemeIcons[key] as React.ComponentType<T>;
        } else {
            return ThemeDefaultIcons[key] as React.ComponentType<T>;
        }
    }

    get addIcon() {
        return this._getIcon("addIcon");
    }

    get infoIcon() {
        return this._getIcon("infoIcon");
    }

    get backIcon() {
        return this._getIcon("backIcon");
    }

    get forwardIcon() {
        return this._getIcon("forwardIcon");
    }

    get closeIcon() {
        return this._getIcon("closeIcon");
    }

    get helpIcon() {
        return this._getIcon("helpIcon");
    }

    get safeZoneIcon() {
        return this._getIcon("safeZoneIcon");
    }

    get twoCharsIcon() {
        return this._getIcon<ITwoCharsIconProps>("twoCharsIcon");
    }

    get earthGlobeIcon() {
        return this._getIcon("earthGlobeIcon");
    }

    get topGamesIcon() {
        return this._getIcon("topGamesIcon");
    }
    get rouletteIcon() {
        return this._getIcon("rouletteIcon");
    }
    get blackjackIcon() {
        return this._getIcon("blackjackIcon");
    }
    get eliteLoungeIcon() {
        return this._getIcon("eliteLoungeIcon");
    }
    get pokerIcon() {
        return this._getIcon("pokerIcon");
    }
    get baccaratIcon() {
        return this._getIcon("baccaratIcon");
    }
    get gameShowsIcon() {
        return this._getIcon("gameShowsIcon");
    }
    get newGamesIcon() {
        return this._getIcon("newGamesIcon");
    }
    get linkToOfferIcon() {
        return this._getIcon("linkToOfferIcon");
    }

    get linkToOfferCloseIcon() {
        return this._getIcon("linkToOfferCloseIcon");
    }
    get sourceOfFundsIcon(){
        return this._getIcon('sourceOfFundsIcon');
    }

    get arrowsUpDownIcon() {
        return this._getIcon('arrowsUpDownIcon');
    }
    get megaphoneIcon() {
        return this._getIcon('megaphoneIcon');
    }
    get chipIcon() {
        return this._getIcon('chipIcon');
    }
    get settingsIcon() {
        return this._getIcon('settingsIcon');
    }

    get viewersIcon() {
        return this._getIcon('viewersIcon');
    }

    get muteIcon() {
        return this._getIcon('muteIcon');
    }

    get unmuteIcon() {
        return this._getIcon('unmuteIcon');
    }

    get brokenLinkIcon() {
        return this._getIcon('brokenLinkIcon');
    }

    get timeSpentReminderClockIcon() {
        return this._getIcon('timeSpentReminderClockIcon');
    }

    get paymentsRedirectIcon() {
        return this._getIcon('paymentsRedirectIcon');
    }

    get tripleEightExclusiveIcon() {
        return this._getIcon('tripleEightExclusiveIcon');
    }

    get leftArrowIcon() {
        return this._getIcon('leftArrowIcon');
    }

    get rightArrowIcon() {
        return this._getIcon('rightArrowIcon');
    }

    get locationIcon() {
        return this._getIcon<ILocationIconProps>('locationIcon');
    }

    get searchIcon() {
        return this._getIcon("searchIcon");
    }

    get sideMenuBlog() {
        return this._getIcon("sideMenuBlog");
    }

    get sideMenuHome() {
        return this._getIcon("sideMenuHome");
    }

    get sideMenuPromotions() {
        return this._getIcon("sideMenuPromotions");
    }

    get sideMenuSlots() {
        return this._getIcon("sideMenuSlots");
    }

    get sideMenuJackpots() {
        return this._getIcon("sideMenuJackpots");
    }

    get sideMenuLiveCasino() {
        return this._getIcon("sideMenuLiveCasino");
    }

    get sideMenuVip() {
        return this._getIcon("sideMenuVip");
    }

    get sideMenuNewGames() {
        return this._getIcon("sideMenuNewGames");
    }

    get sideMenuCasinoGames() {
        return this._getIcon("sideMenuCasinoGames");
    }

    get sideMenuExclusive888() {
        return this._getIcon("sideMenuExclusive888");
    }

    get sideMenuBlackjack() {
        return this._getIcon("sideMenuBlackjack");
    }
    get sideMenuRoulette() {
        return this._getIcon("sideMenuRoulette");
    }
    get sideMenuGettingStarted() {
        return this._getIcon("sideMenuGettingStarted");
    }
    get sideMenuBanking() {
        return this._getIcon("sideMenuBanking");
    }
    get sideMenuLiveChat() {
        return this._getIcon("sideMenuLiveChat");
    }
    get sideMenuDownloadApp() {
        return this._getIcon("sideMenuDownloadApp");
    }
    get sideMenuClub888() {
        return this._getIcon("sideMenuClub888");
    }
    get sideMenuPokerCircle() {
        return this._getIcon("sideMenuPokerCircle");
    }
    get sideMenuSportCircle() {
        return this._getIcon("sideMenuSportCircle");
    }
    get sideMenuVideoPoker() {
        return this._getIcon("sideMenuVideoPoker");
    }
    get sideMenuDeposit() {
        return this._getIcon("sideMenuDeposit");
    }

    get freeplayIcon() {
        return this._getIcon("freeplayIcon");
    }

    get notificationIcon() {
        return this._getIcon("notificationIcon");
    }
    get sideMenuHelp() {
        return this._getIcon("sideMenuHelp");
    }

    get warningSignIcon() {
        return this._getIcon("warningSignIcon");
    }

    get usaMapIcon() {
        return this._getIcon("usaMapIcon");
    }
}